<div class="catalogs-container">
  <mat-card class="mb-25 tagus-card search-card">
    <mat-card-content>
      <div class="search-row">
        <mat-form-field appearance="outline" class="search-field">
          <mat-label>Número de teléfono</mat-label>
          <input
            matInput
            [(ngModel)]="searchPhone"
            placeholder="Ej: 573001234567"
            (keyup.enter)="search()"
          />
          <mat-icon matPrefix>phone</mat-icon>
        </mat-form-field>
        <button
          mat-flat-button
          class="default-btn bg-color-blue-button search-btn"
          (click)="search()"
        >
          <mat-icon>search</mat-icon> Buscar
        </button>
        <span class="spacer"></span>
        <button
          mat-flat-button
          class="default-btn bg-color-blue-button"
          (click)="newCatalog()"
        >
          <mat-icon>add</mat-icon> Nuevo catálogo
        </button>
      </div>
    </mat-card-content>
  </mat-card>

  <mat-card class="mb-25 tagus-card" *ngIf="currentPhone">
    <mat-card-content>
      <mat-tab-group animationDuration="0ms">
        <!-- ─────────── Borradores ─────────── -->
        <mat-tab label="Borradores">
          <div
            class="tagus-mat-table mat-elevation-z8 mt-15"
            *ngIf="drafts.length > 0; else noDrafts"
          >
            <table mat-table [dataSource]="drafts" class="table-responsive">
              <ng-container matColumnDef="business">
                <th mat-header-cell *matHeaderCellDef>Negocio</th>
                <td mat-cell *matCellDef="let el">
                  {{ el.business_info?.name || "Sin nombre" }}
                </td>
              </ng-container>

              <ng-container matColumnDef="products">
                <th mat-header-cell *matHeaderCellDef>Productos</th>
                <td mat-cell *matCellDef="let el">{{ el.products?.length || 0 }}</td>
              </ng-container>

              <ng-container matColumnDef="template">
                <th mat-header-cell *matHeaderCellDef>Plantilla</th>
                <td mat-cell *matCellDef="let el">{{ templateLabel(el.template) }}</td>
              </ng-container>

              <ng-container matColumnDef="status">
                <th mat-header-cell *matHeaderCellDef>Estado</th>
                <td mat-cell *matCellDef="let el">
                  <span class="status-badge status-{{ el.status }}">
                    {{ statusLabel(el.status) }}
                  </span>
                </td>
              </ng-container>

              <ng-container matColumnDef="updated">
                <th mat-header-cell *matHeaderCellDef>Actualizado</th>
                <td mat-cell *matCellDef="let el">
                  {{ el.updated_at | date: "dd/MM/yyyy HH:mm" }}
                </td>
              </ng-container>

              <ng-container matColumnDef="action">
                <th mat-header-cell *matHeaderCellDef>Acciones</th>
                <td mat-cell *matCellDef="let el">
                  <button
                    mat-icon-button
                    class="blue-color"
                    matTooltip="Editar"
                    (click)="edit(el)"
                  >
                    <mat-icon>edit</mat-icon>
                  </button>
                  <button
                    mat-icon-button
                    class="blue-color"
                    matTooltip="Duplicar"
                    (click)="duplicate(el.draft_id)"
                  >
                    <mat-icon>content_copy</mat-icon>
                  </button>
                  <button
                    *ngIf="el.catalog_pdf_url"
                    mat-icon-button
                    class="blue-color"
                    matTooltip="Descargar PDF"
                    (click)="downloadPdf(el.catalog_pdf_url)"
                  >
                    <mat-icon>picture_as_pdf</mat-icon>
                  </button>
                </td>
              </ng-container>

              <tr mat-header-row *matHeaderRowDef="draftColumns"></tr>
              <tr mat-row *matRowDef="let row; columns: draftColumns"></tr>
            </table>

            <mat-paginator
              [length]="draftsTotal"
              [pageSize]="draftsPageSize"
              [pageIndex]="draftsPage"
              [pageSizeOptions]="[10, 20, 50]"
              (page)="onDraftsPage($event)"
              showFirstLastButtons
            ></mat-paginator>
          </div>

          <ng-template #noDrafts>
            <div class="no-results">
              <mat-icon>drafts</mat-icon>
              <p>No hay borradores para este número.</p>
            </div>
          </ng-template>
        </mat-tab>

        <!-- ─────────── Completados ─────────── -->
        <mat-tab label="Completados">
          <div
            class="tagus-mat-table mat-elevation-z8 mt-15"
            *ngIf="completed.length > 0; else noCompleted"
          >
            <table mat-table [dataSource]="completed" class="table-responsive">
              <ng-container matColumnDef="business">
                <th mat-header-cell *matHeaderCellDef>Negocio</th>
                <td mat-cell *matCellDef="let el">{{ el.business_name }}</td>
              </ng-container>

              <ng-container matColumnDef="products">
                <th mat-header-cell *matHeaderCellDef>Productos</th>
                <td mat-cell *matCellDef="let el">{{ el.products_count }}</td>
              </ng-container>

              <ng-container matColumnDef="completed">
                <th mat-header-cell *matHeaderCellDef>Completado</th>
                <td mat-cell *matCellDef="let el">
                  {{ el.completed_at | date: "dd/MM/yyyy HH:mm" }}
                </td>
              </ng-container>

              <ng-container matColumnDef="action">
                <th mat-header-cell *matHeaderCellDef>Acciones</th>
                <td mat-cell *matCellDef="let el">
                  <button
                    mat-icon-button
                    class="blue-color"
                    matTooltip="Descargar PDF"
                    (click)="downloadPdf(el.pdf_url)"
                  >
                    <mat-icon>picture_as_pdf</mat-icon>
                  </button>
                  <button
                    mat-icon-button
                    class="blue-color"
                    matTooltip="Compartir"
                    (click)="share(el.draft_id)"
                  >
                    <mat-icon>share</mat-icon>
                  </button>
                  <button
                    mat-icon-button
                    class="blue-color"
                    matTooltip="Duplicar"
                    (click)="duplicate(el.draft_id)"
                  >
                    <mat-icon>content_copy</mat-icon>
                  </button>
                </td>
              </ng-container>

              <tr mat-header-row *matHeaderRowDef="completedColumns"></tr>
              <tr mat-row *matRowDef="let row; columns: completedColumns"></tr>
            </table>

            <mat-paginator
              [length]="completedTotal"
              [pageSize]="completedPageSize"
              [pageIndex]="completedPage"
              [pageSizeOptions]="[10, 20, 50]"
              (page)="onCompletedPage($event)"
              showFirstLastButtons
            ></mat-paginator>
          </div>

          <ng-template #noCompleted>
            <div class="no-results">
              <mat-icon>menu_book</mat-icon>
              <p>No hay catálogos completados para este número.</p>
            </div>
          </ng-template>
        </mat-tab>
      </mat-tab-group>
    </mat-card-content>
  </mat-card>
</div>
